'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "index", "message", "onToolCall", "part", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useChatLocaleText } from "../../chat/internals/ChatLocaleContext.js";
import { useMessageContentTabIndex } from "../../message-list/internals/MessageRovingContext.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ReasoningPart = /*#__PURE__*/React.forwardRef(function ReasoningPart(props, ref) {
  const {
      className,
      index,
      message,
      onToolCall,
      part,
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  void index;
  void onToolCall;
  const localeText = useChatLocaleText();
  const ownerState = React.useMemo(() => ({
    messageId: message.id,
    role: message.role,
    streaming: part.state === 'streaming'
  }), [message.id, message.role, part.state]);
  const Root = slots?.root ?? 'details';
  const Summary = slots?.summary ?? 'summary';
  const Content = slots?.content ?? 'div';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref,
      open: ownerState.streaming,
      className
    }
  });
  // Inside a roving message list the summary leaves the tab order until the
  // user drills into the message (Enter); it stays mouse-clickable.
  const contentTabIndex = useMessageContentTabIndex();
  const summaryProps = useSlotProps({
    elementType: Summary,
    externalSlotProps: slotProps?.summary,
    ownerState,
    additionalProps: {
      tabIndex: contentTabIndex
    }
  });
  const contentProps = useSlotProps({
    elementType: Content,
    externalSlotProps: slotProps?.content,
    ownerState
  });
  return /*#__PURE__*/_jsxs(Root, _extends({}, rootProps, {
    children: [/*#__PURE__*/_jsx(Summary, _extends({}, summaryProps, {
      children: ownerState.streaming ? localeText.messageReasoningStreamingLabel : localeText.messageReasoningLabel
    })), /*#__PURE__*/_jsx(Content, _extends({}, contentProps, {
      children: part.text
    }))]
  }));
});
if (process.env.NODE_ENV !== "production") ReasoningPart.displayName = "ReasoningPart";
export function createReasoningPartRenderer(defaultProps = {}) {
  return function ReasoningPartRenderer(rendererProps) {
    return /*#__PURE__*/_jsx(ReasoningPart, _extends({}, defaultProps, rendererProps));
  };
}